// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDuplicateClaimDto } from './IDuplicateClaimDto';
import {
    IDuplicateClaimDtoFromJSON,
    IDuplicateClaimDtoFromJSONTyped,
    IDuplicateClaimDtoToJSON,
    IDuplicateClaimDtoToJSONTyped,
} from './IDuplicateClaimDto';
import type { IOcrFieldStateDto } from './IOcrFieldStateDto';
import {
    IOcrFieldStateDtoFromJSON,
    IOcrFieldStateDtoFromJSONTyped,
    IOcrFieldStateDtoToJSON,
    IOcrFieldStateDtoToJSONTyped,
} from './IOcrFieldStateDto';

/**
 * 
 * @export
 * @interface IOcrDetailsDto
 */
export interface IOcrDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof IOcrDetailsDto
     */
    ocr_receipt_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IOcrDetailsDto
     */
    receipt_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IOcrDetailsDto
     */
    duplicate_document_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IOcrDetailsDto
     */
    duplicate_claim_id?: number;
    /**
     * 
     * @type {IDuplicateClaimDto}
     * @memberof IOcrDetailsDto
     */
    duplicate_claim?: IDuplicateClaimDto;
    /**
     * 
     * @type {string}
     * @memberof IOcrDetailsDto
     */
    ocr_type?: IOcrDetailsDtoOcrTypeEnum;
    /**
     * 
     * @type {IOcrFieldStateDto}
     * @memberof IOcrDetailsDto
     */
    facility_name?: IOcrFieldStateDto;
    /**
     * 
     * @type {IOcrFieldStateDto}
     * @memberof IOcrDetailsDto
     */
    patient?: IOcrFieldStateDto;
    /**
     * 
     * @type {IOcrFieldStateDto}
     * @memberof IOcrDetailsDto
     */
    service_date?: IOcrFieldStateDto;
    /**
     * 
     * @type {IOcrFieldStateDto}
     * @memberof IOcrDetailsDto
     */
    amount?: IOcrFieldStateDto;
    /**
     * 
     * @type {IOcrFieldStateDto}
     * @memberof IOcrDetailsDto
     */
    service?: IOcrFieldStateDto;
    /**
     * 
     * @type {IOcrFieldStateDto}
     * @memberof IOcrDetailsDto
     */
    account?: IOcrFieldStateDto;
    /**
     * 
     * @type {IOcrFieldStateDto}
     * @memberof IOcrDetailsDto
     */
    invoice?: IOcrFieldStateDto;
    /**
     * 
     * @type {Set<number>}
     * @memberof IOcrDetailsDto
     */
    duplicate_claim_ids?: Set<number>;
    /**
     * 
     * @type {Array<IDuplicateClaimDto>}
     * @memberof IOcrDetailsDto
     */
    duplicate_claims?: Array<IDuplicateClaimDto>;
}

/**
* @export
* @enum {string}
*/
export enum IOcrDetailsDtoOcrTypeEnum {
    REIMBURSEMENT_ME = 'REIMBURSEMENT_ME',
    DOCS_NEEDED = 'DOCS_NEEDED',
    CARD_CLAIM = 'CARD_CLAIM'
}


/**
 * Check if a given object implements the IOcrDetailsDto interface.
 */
export function instanceOfIOcrDetailsDto(value: object): value is IOcrDetailsDto {
    return true;
}

export function IOcrDetailsDtoFromJSON(json: any): IOcrDetailsDto {
    return IOcrDetailsDtoFromJSONTyped(json, false);
}

export function IOcrDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ocr_receipt_id': json['ocr_receipt_id'] == null ? undefined : json['ocr_receipt_id'],
        'receipt_id': json['receipt_id'] == null ? undefined : json['receipt_id'],
        'duplicate_document_id': json['duplicate_document_id'] == null ? undefined : json['duplicate_document_id'],
        'duplicate_claim_id': json['duplicate_claim_id'] == null ? undefined : json['duplicate_claim_id'],
        'duplicate_claim': json['duplicate_claim'] == null ? undefined : IDuplicateClaimDtoFromJSON(json['duplicate_claim']),
        'ocr_type': json['ocr_type'] == null ? undefined : json['ocr_type'],
        'facility_name': json['facility_name'] == null ? undefined : IOcrFieldStateDtoFromJSON(json['facility_name']),
        'patient': json['patient'] == null ? undefined : IOcrFieldStateDtoFromJSON(json['patient']),
        'service_date': json['service_date'] == null ? undefined : IOcrFieldStateDtoFromJSON(json['service_date']),
        'amount': json['amount'] == null ? undefined : IOcrFieldStateDtoFromJSON(json['amount']),
        'service': json['service'] == null ? undefined : IOcrFieldStateDtoFromJSON(json['service']),
        'account': json['account'] == null ? undefined : IOcrFieldStateDtoFromJSON(json['account']),
        'invoice': json['invoice'] == null ? undefined : IOcrFieldStateDtoFromJSON(json['invoice']),
        'duplicate_claim_ids': json['duplicate_claim_ids'] == null ? undefined : new Set(json['duplicate_claim_ids']),
        'duplicate_claims': json['duplicate_claims'] == null ? undefined : ((json['duplicate_claims'] as Array<any>).map(IDuplicateClaimDtoFromJSON)),
    };
}

export function IOcrDetailsDtoToJSON(json: any): IOcrDetailsDto {
    return IOcrDetailsDtoToJSONTyped(json, false);
}

export function IOcrDetailsDtoToJSONTyped(value?: IOcrDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ocr_receipt_id': value['ocr_receipt_id'],
        'receipt_id': value['receipt_id'],
        'duplicate_document_id': value['duplicate_document_id'],
        'duplicate_claim_id': value['duplicate_claim_id'],
        'duplicate_claim': IDuplicateClaimDtoToJSON(value['duplicate_claim']),
        'ocr_type': value['ocr_type'],
        'facility_name': IOcrFieldStateDtoToJSON(value['facility_name']),
        'patient': IOcrFieldStateDtoToJSON(value['patient']),
        'service_date': IOcrFieldStateDtoToJSON(value['service_date']),
        'amount': IOcrFieldStateDtoToJSON(value['amount']),
        'service': IOcrFieldStateDtoToJSON(value['service']),
        'account': IOcrFieldStateDtoToJSON(value['account']),
        'invoice': IOcrFieldStateDtoToJSON(value['invoice']),
        'duplicate_claim_ids': value['duplicate_claim_ids'] == null ? undefined : Array.from(value['duplicate_claim_ids'] as Set<any>),
        'duplicate_claims': value['duplicate_claims'] == null ? undefined : ((value['duplicate_claims'] as Array<any>).map(IDuplicateClaimDtoToJSON)),
    };
}

